/**
 * This file can be replaced during build by using the `fileReplacements` array.
 * `ng build` replaces `environment.ts` with `environment.prod.ts`.
 * The list of file replacements can be found in `angular.json`.
 */

import { StoreDevtoolsModule } from "@ngrx/store-devtools";
/**
 * The `environment` object is used to configure settings for the Angular application.
 * This file contains development-specific configuration settings that are different from production settings.
 */
export const environment = {
    production: false,
  apiBaseUrl: 'https://api.qa.bpx-qc-analysis.com/',
    dummy_JSONs: false,
    includeNgrxDevStore: [
      StoreDevtoolsModule.instrument({ name: 'Unity ngrx DevTools', maxAge: 25 })
  ],
  msalConfig: {
    auth: {
      clientId: 'c16f3882-f556-4124-9c29-727e6e4789ee',
      authority: 'https://login.microsoftonline.com/ef0aebeb-2af0-47a3-b8ae-5665f8a62d11'
    }
  },
  apiConfig: {
    scopes: ['c16f3882-f556-4124-9c29-727e6e4789ee/.default'],
    uri: 'https://graph.microsoft.com/v1.0/me'
   // token_uri: 'https://login.microsoftonline.com/ef0aebeb-2af0-47a3-b8ae-5665f8a62d11/oauth2/v2.0/token'
  }
};
